<template>
    <div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
        <form action="ohyes" method="POST" id='create_form' @submit.prevent="form_submit()">
            <input id="create_status" type="hidden" value="error">
            <div class="modal-content">
                <div class="modal-header bg-system">
                    <strong class="modal-title text-white">Create Expense</strong>
                    <button @click="triggerReset()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="text-white" aria-hidden="true" >&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group mb-1">
                        <label>
                            Expense Category <span class="text-danger">*</span>
                        </label>
                        <template v-if="expense_categories">
                            <select v-model="expense_category_id" id="product" class="border-page-color selectPicker form-control" data-live-search="true" required>
                                <option value="">PLEASE SELECT ONE</option>
                                <option :value="expense.id" v-for="expense in expense_categories" :key="expense.id">{{ expense.name }}</option>
                            </select>
                        </template>
                    </div>
                    <div class="form-group mb-1">
                        <label>
                            Expense Date <span class="text-danger">*</span>
                        </label>
                        <input v-model="expense_date" type="date" class="form-control" required>
                    </div>
                    <div class="form-group mb-1">
                        <label>
                            Amount <span class="text-danger">*</span>
                        </label>
                        <input v-model="amount" type="text" class="form-control"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                            required
                        >
                    </div>
                    <div class="form-group mb-1">
                        <label>
                            Description / Note
                        </label>
                        <input v-model="description" type="text" class="form-control">
                    </div>
                    <div class="form-group mb-1">
                        <label for="">Image</label>
                        <div class="w-100">
                            <input id="photo" @change="changeImg('photo',$event)" type="file">
                            <button @click="resetImg('photo')" type="button" v-if="pho" title="Reset Photo" class="border-0 rounded outline-0 float-right btn-outline-dark"><i class="fas fa-redo-alt"></i></button>
                            <img v-if="phoo" :src="photo" class="my-2 w-25 rounded-circle">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button :disabled="isCreate" id="save" type="submit" class="btn btn-system btn-xs">
                        <img v-if="isCreate" src="../../assets/sniper.jpeg" alt="" width="12">
                        <i v-else class="fa fa-save"></i> Save
                    </button>
                    <button type="button" class="btn btn-danger btn-xs" data-dismiss="modal" 
                        @click="triggerReset()">
                        <i class="fa fa-times"></i> Close
                    </button>
                </div>
            </div>
        </form>
        </div>
    </div>  
</template> 
<script>
import { frm_submit } from '@/networks/services/helper/button'
import { user } from '@/networks/services/auth/user.service'

export default {
    props : {
        expense_categories : {
            type : [Object , Array],
            default : []
        }
    },
    data(){
        return {
            expense_category_id : '',
            tbl : "expenses",
            per : "expense",
            expense_date : "",
            description : "",
            amount : "",
            photo : '',
            pho: false,
            phoo: null,
            isCreate : false,
        }
    },
    methods: {
        triggerReset(){
            // $('#createModal').on('hidden.bs.modal', function () {
            //     $(this).find('form').trigger('reset');
            // })
            this.expense_category_id = '';
            this.expense_date = '';
            this.description = '';
            this.amount = '';
            this.photo = '';
            this.pho = false,
            this.phoo = null;
            this.isCreate = false;
        },
        resetImg(value){
            if(value == "photo"){
                this.photo = '';
                this.pho = false;
                this.phoo = null;
                $('#photo').val('');
            }
        },
        changeImg(value,obj){
            if(value == "photo"){
                this.photo = URL.createObjectURL(obj.target.files[0]);
                this.phoo = obj.target.files[0];
                this.pho = true;
            }
        },
        async form_submit(){
            this.isCreate = true;
            $('#save').prop('disabled', true);
            let com_id = user('company_id');
            let data = new FormData();
            data.append('tbl',this.tbl);
            data.append('per',this.per);
            data.append('company_id',com_id);
            data.append('expense_category_id',this.expense_category_id);
            data.append('expense_date',this.expense_date);
            data.append('amount',this.amount);
            data.append('photo',this.phoo);
            data.append('description',this.description);
            await frm_submit(data);
            $('#save').prop('disabled', false);
            this.triggerReset();
            this.resetImg("photo");
            this.$emit("createModal",$('#create_status').val()); 

        },
    },
    mounted(){
        $(document).ready(function() {
            $('.chosen2').select2();
        });
    }
}
</script>
